import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

/**
 * Shares "how many hot games are there" between the games list (which knows
 * the hot tags) and the sidebar (which shows the Hot Games tab), and scrolls
 * to the hot games section.
 */
@Injectable({
  providedIn: 'root',
})
export class HotGamesService {
  static readonly SECTION_ID = 'hot-games-section';

  private hotCount = new BehaviorSubject<number>(0);
  hotCount$ = this.hotCount.asObservable();

  constructor(private router: Router) {}

  setHotCount(count: number) {
    if (count !== this.hotCount.value) {
      this.hotCount.next(count);
    }
  }

  scrollToHotGames() {
    const scroll = () => {
      const el = document.getElementById(HotGamesService.SECTION_ID);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return !!el;
    };

    if (scroll()) return;

    // Not on the page that has the games yet, go to the dashboard home first
    this.router.navigate(['/dashboard/home']).then(() => {
      setTimeout(scroll, 600);
    });
  }
}
